import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcReset = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path
        d="M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2Zm4.95 7.636L16 14.586l-4.95-4.95-1.414 1.414 4.95 4.95-4.95 4.95 1.414 1.414 4.95-4.95 4.95 4.95 1.414-1.414-4.95-4.95 4.95-4.95-1.414-1.414Z"
        id="ic_reset_svg__a"
      />
    </defs>
    <use fill="currentColor" xlinkHref="#ic_reset_svg__a" fillRule="evenodd" />
  </svg>
);
export default SvgIcReset;
